export const questionIconCss = {
  root: {
    padding: "0.25rem",
    width: "2rem",
    height: "2rem",
  },
};

export const supportCenterButtonCss = {
  root: {
    display: "flex",

    ":hover": {
      background: "rgba(29, 29, 29, 0.08)",
    },
  },
};

export const supportCenterVisibilityCss = {
  display: "flex",
};
